module.exports = __webpack_public_path__ + "img/icon-locket.88f2cab7.svg";